import {localStorage} from "@/utils/local-storage";
import {changeProjectId} from "@/api/project/project";

const CACHE_KEY_ROOM_ID = 'currentRoomId';
const CACHE_KEY_PROJECT_ID = 'currentProjectId';
const CACHE_KEY_TENANT_ID = 'currentTenantId';

export async function getCachedRoomId(): Promise<string | null> {
  const cached = localStorage.get(CACHE_KEY_ROOM_ID);
  if (cached) return cached;
  try {
    const res = await import('@/api/project/project').then(m => m.getCurrentRoomId());
    if (res && res.data) {
      const dataStr = typeof res.data === 'string' ? res.data : JSON.stringify(res.data);
      localStorage.set(CACHE_KEY_ROOM_ID, dataStr);
      return dataStr;
    }
    return null;
  } catch (error) {
    console.error('获取 roomId 失败:', error);
    return null;
  }
}

export async function getCachedProjectIdWithoutCache(): Promise<string | null> {
  try {
    const res = await import('@/api/project/project').then(m => m.getCurrentProjectId());
    if (res && res.data) {
      const dataStr = typeof res.data === 'string' ? res.data : JSON.stringify(res.data);
      localStorage.set(CACHE_KEY_PROJECT_ID, dataStr);
      return dataStr;
    }
    return null;
  } catch (error) {
    console.error('获取 projectId 失败:', error);
    return null;
  }
}

export async function getCachedProjectId(): Promise<string | null> {
  const cached = localStorage.get(CACHE_KEY_PROJECT_ID);
  if (cached) return cached;
  return getCachedProjectIdWithoutCache();
}

/**
 * 设置当前项目的 tenantId 并缓存
 * @param projectId 项目ID
 */
export async function setCachedTenantId(tenantId: string): Promise<void> {
  localStorage.set(CACHE_KEY_TENANT_ID, tenantId);
  // 主动触发 tenantId 变化的回调
  const newProjectId = localStorage.get(CACHE_KEY_PROJECT_ID);
  const newRoomId = localStorage.get(CACHE_KEY_ROOM_ID);


  if (typeof onProjectIdChangeWithTenant === 'function') {
    onProjectIdChangeWithTenant(newProjectId, newRoomId, tenantId);
  }
}

export async function getCachedTenantId(): Promise<string | null> {
  const cached = localStorage.get(CACHE_KEY_TENANT_ID);
  return cached;
}

/**
 * 设置当前项目的 projectId 并缓存
 * @param projectId 项目ID
 */
export async function setCachedProjectId(projectId: string): Promise<void> {
  localStorage.set(CACHE_KEY_PROJECT_ID, projectId);
  // 改也变缓存的roomId
  if (!projectId) {
    setCachedRoomId(null)
    return;
  }
  const roomRes = await changeProjectId({projectId: projectId});
  if (roomRes && roomRes.data) {
    // 手动触发回调
    if (typeof onProjectIdChange === 'function') {
      onProjectIdChange(projectId, roomRes.data['id']);
    }
    setCachedRoomId(roomRes.data['id'])
  }
}

/**
 * 设置当前项目的 projectId 并缓存
 * @param projectId 项目ID
 */
export function setCachedRoomId(roomId: string): void {
  localStorage.set(CACHE_KEY_ROOM_ID, roomId);

}

// 监听 localStorage 变化
window.addEventListener('storage', async (event) => {
  console.log('storage event:', event.key, event.newValue);
  if (event.key === CACHE_KEY_PROJECT_ID || event.key === CACHE_KEY_TENANT_ID) {
    debugger
    // 如果是 projectId 的变化，可以触发回调
    const newProjectId = localStorage.get(CACHE_KEY_PROJECT_ID);
    const newRoomId = localStorage.get(CACHE_KEY_ROOM_ID);
    const tenantId = localStorage.get(CACHE_KEY_TENANT_ID);

    if (typeof onProjectIdChange === 'function' && event.key === CACHE_KEY_PROJECT_ID) {
      onProjectIdChange(newProjectId, newRoomId);
    }

    // 调用新版本回调
    if (typeof onProjectIdChangeWithTenant === 'function' && event.key === CACHE_KEY_TENANT_ID) {
      onProjectIdChangeWithTenant(newProjectId, newRoomId, tenantId);
    }
  }
});

let onProjectIdChange: ((newId: string | null, newRoomId: string | null) => void) | null = null;
// 新增一个专门处理 tenantId 的回调
let onProjectIdChangeWithTenant: ((newId: string | null, newRoomId: string | null, tenantId: string | null) => void) | null = null;


export function setOnProjectIdChangeListener(callback: (newId: string | null, newRoomId: string | null, tenantId?: string | null) => void) {
  console.log('监听器已绑定');
  onProjectIdChange = callback;
}

export function clearOnProjectIdChangeListener() {
  onProjectIdChange = null;
}

export function setOnProjectIdChangeListenerWithTenant(
  callback: (newId: string | null, newRoomId: string | null, tenantId: string | null) => void
) {
  console.log('带租户ID的监听器已绑定');
  onProjectIdChangeWithTenant = callback;
}